import {useEffect, useState} from "react";
import HomeRight from "../../../../assets/images/home_right.png"
import CheckCircleIcon from "../../../../assets/images/circle-check.png"
import DashedCircleIcon from "../../../../assets/images/dashed-check.png"
import GreatIcon from "../../../../assets/images/icon-great.png"
import BadIcon from "../../../../assets/images/icon-bad.png"
import ArrowDownIcon from "../../../../assets/images/arrow-down.png"
import * as React from "react";
import {useNavigate} from "react-router-dom";

const StageBadge = ({index, grade, semester, stageSummary, classInfo, notStartedComment}) => {

    const [stageInfo, setStageInfo] = useState(null);
    const [lessonInfo, setLessonInfo] = useState(null);
    const [notStartedStudents, setNotStartedStudents] = useState([]);
    const [completedStudents, setCompletedStudents] = useState([]);
    const [guidanceNeededStudents, setGuidanceNeededStudents] = useState([]);
    const [activeDate, setActiveDate] = useState(null);
    const [showTooltip, setShowTooltip] = React.useState(false); // 툴팁 상태 관리
    const [showTooltipGuidanceNeeded, setShowTooltipGuidanceNeeded] = React.useState(false); // 툴팁 상태 관리
    const navigate = useNavigate();


    const thumbNailDomain = "https://sym008463-sym008463.ktcdn.co.kr/stage_thumbnails/";

    const getThumbnailUrl = (fileName) => {
        return thumbNailDomain+fileName+".png";
    }

    const lessonDetail = () => {
        navigate("/page/classLessonStage?classId="+classInfo.classId+"&stageId="+stageInfo.stageId+"&lessonInfoId="+lessonInfo.lessonInfoId)
    }


    useEffect(() => {
        if(stageSummary){
            setStageInfo(stageSummary.stageInfo);
            setLessonInfo(stageSummary.lessonInfo);
            setNotStartedStudents(stageSummary.notStartedStudents);
            setCompletedStudents(stageSummary.completedStudents);
            setGuidanceNeededStudents(stageSummary.guidanceNeededStudents);
            setActiveDate(stageSummary.activeDate);
        }
    }, [stageSummary]);


    return (
        <div className="flex flex-col w-full max-w-[510px] mb-5">
            <div
                className="flex items-center gap-[9px] rounded-t-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom pt-[18px] pb-[15px] px-[13px]">
                <div
                    className="flex justify-center items-center text-[#BEC3CF] text-[17px] text-center font-[700] w-[30px] h-[30px] border-[2px] border-[#BEC3CF] rounded-full px-2">
                    {index + 1}
                </div>
                <div className="flex justify-between items-center w-full">
                    <div
                        className="items-center text-[#50555F] text-[17px] font-[700] w-[330px]  truncate whitespace-nowrap overflow-hidden text-left">
                        {stageInfo && stageInfo.stageName}
                    </div>

                    <div
                        className="flex flex-row min-w-[100px] justify-end items-center text-[#50555F] text-[14px] font-[800] cursor-pointer h-[18px] gap-[6px]"
                        onClick={lessonDetail}
                    >
                        <div className=" flex justify-end  items-center pb-[1px]">상세보기</div>

                        <img
                            src={HomeRight}
                            alt="right"
                            className="ml-1 w-[8px] items-center"
                        />
                    </div>
                </div>
            </div>
            <div
                className="flex justify-between items-center rounded-b-[20px] border-[1px] border-[#DADADA] bg-white shadow-custom px-[17px] py-[16px] mt-[-1px]">
            <div className="flex justify-center items-center gap-5">
                    <img
                        className=" w-[154px] h-[92px] rounded-[10px]"
                        src={stageInfo && getThumbnailUrl(stageInfo.thumbNail)}
                        alt="stage thumbnail"></img>

                </div>
                {stageSummary.activeDate !== null ? (
                    <div className="inline-flex items-center gap-[10px]">
                        <div
                            className={`flex flex-col w-[61px] gap-[4px] items-center justify-center relative ${notStartedStudents.length > 0 && 'cursor-zoom-in'}`}
                            onMouseEnter={() => notStartedStudents && notStartedStudents.length > 0 && setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                        >
                            <img className="w-[28px]" src={DashedCircleIcon} alt="check-circle" />
                            <div className="flex flex-col">
                                <div className="text-[#50555F] text-[16px] font-[700]">미진행</div>
                                <div className="text-[#7494FF] text-[16px] font-[700]">
                                    {notStartedStudents && notStartedStudents.length}명
                                </div>
                            </div>
                            {/* 툴팁 표시 */}
                            {showTooltip && notStartedStudents && notStartedStudents.length > 0 && (
                                <div className="absolute mt-[-104px] -translate-y-1/2 left-[50%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-2 shadow-lg z-10 max-w-[150px] text-center">
                                    <div className="whitespace-nowrap overflow-ellipsis overflow-hidden">
                                        {notStartedStudents.map((student, index) => index < 4 ? (
                                            <div key={index}>{student}</div>
                                        ) : "")}
                                        {notStartedStudents.length > 4 && "..."}
                                    </div>
                                    <img
                                        src={ArrowDownIcon}
                                        alt="arrow down icon"
                                        className="absolute bottom-[-10px] left-[50%] -translate-x-1/2 w-[8px]"
                                    />
                                </div>
                            )}
                        </div>

                        <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>

                        <div className="flex flex-col w-[61px] gap-[3px] items-center justify-center">
                            <img className="w-[28px]" src={CheckCircleIcon} alt="check-circle" />
                            <div className="flex flex-col">
                                <div className="text-[#50555F] text-[16px] font-[700]">학습완료</div>
                                <div className="text-[#7494FF] text-[16px] font-[700]">
                                    {completedStudents && completedStudents.length}명
                                </div>
                            </div>
                        </div>

                        <div className="flex border-[1px] border-[#EAEAEA] h-[82px]"></div>

                        {completedStudents && completedStudents.length > 0 ? (
                            guidanceNeededStudents && guidanceNeededStudents.length > 0 ? (
                                <div
                                    className={`flex flex-col w-[61px] gap-[3px] items-center justify-center relative ${guidanceNeededStudents.length > 0 && 'cursor-zoom-in'}`}
                                    onMouseEnter={() => guidanceNeededStudents && guidanceNeededStudents.length > 0 && setShowTooltipGuidanceNeeded(true)}
                                    onMouseLeave={() => setShowTooltipGuidanceNeeded(false)}
                                >
                                    <img className="w-[28px]" src={BadIcon} alt="check-circle" />
                                    <div className="flex flex-col">
                                        <div className="text-[#50555F] text-[16px] font-[700]">어려워요</div>
                                        <div className="text-[#FC5955] text-[16px] font-[700]">
                                            {guidanceNeededStudents && guidanceNeededStudents.length}명
                                        </div>
                                    </div>
                                    {/* 툴팁 표시 */}
                                    {showTooltipGuidanceNeeded && guidanceNeededStudents && guidanceNeededStudents.length > 0 && (
                                        <div className="absolute mt-[-104px] -translate-y-1/2 left-[50%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-2 shadow-lg z-10 max-w-[150px] text-center">
                                            <div className="whitespace-nowrap overflow-ellipsis overflow-hidden">
                                                {guidanceNeededStudents.map((student, index) => index < 4 ? (
                                                    <div key={index}>{student}</div>
                                                ) : "")}
                                                {guidanceNeededStudents.length > 4 && "..."}
                                            </div>
                                            <img
                                                src={ArrowDownIcon}
                                                alt="arrow down icon"
                                                className="absolute bottom-[-10px] left-[50%] -translate-x-1/2 w-[8px]"
                                            />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="flex flex-col w-[61px] gap-[3px] items-center justify-center">
                                    <img className="w-[28px]" src={GreatIcon} alt="check-circle" />
                                    <div className="flex flex-col">
                                        <div className="text-[#50555F] text-[16px] font-[700]">모두</div>
                                        <div className="text-[#50555F] text-[16px] font-[700]">잘했어요</div>
                                    </div>
                                </div>
                            )
                        ) : (
                            <div className="flex flex-col w-[61px] gap-[3px] items-center justify-center">
                                -
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="text-[#B0B2B8] text-[16px] font-[700] w-[216px]">{notStartedComment}</div>
                )}
            </div>
        </div>
    )
}


export default StageBadge;